import { type ReactNode } from 'react'
import { ErrorBoundary } from './ErrorBoundary'

/**
 * Composes application-level providers that do NOT depend on React Router.
 * Router-dependent providers (TourProvider, WebSocketProvider) live inside AppLayout.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return <ErrorBoundary>{children}</ErrorBoundary>
}
